define((require) => {
    "use strict";

    var EditorMoreMenuViewController = require("ui/editor/editorMoreMenu/EditorMoreMenuViewController"),
        ImprovedView                 = require("editor/zbone/ImprovedView"),
        LoggedInUserState            = require("shared/ui/user/LoggedInUserState"),
        ShareButton                  = require("ui/share/ShareButton"),
        template                     = require("ui/editor/editorMoreMenu/EditorMoreMenuView.tpl");

    return ImprovedView.extend({

        controller: EditorMoreMenuViewController,

        template: template,

        experienceBindings: {
            ".unread-comments-indicator": {
                observe: "unread",
                updateView: true,
                visible: function(value) {
                    return value > 0;
                }
            }
        },

        bindings: {
            ".toggle-comments": {
                attributes: [{
                    name: "class",
                    observe: "showComments",
                    onGet: function(showComments) {
                        return "toggle-comments" + (showComments ? " comments-shown" : "");
                    }
                }]
            },
            ".add-comment": {
                attributes: [{
                    name: "class",
                    observe: "showComments",
                    onGet: function(showComments) {
                        return "add-comment" + (showComments ? " comments-shown" : "");
                    }
                }]
            }
        },

        triggers: {
            "click @ui.toggleComments":  "toggleComments", // See EditorMoreMenuViewController
            "click @ui.addComment":      "addComment"      // See EditorMoreMenuViewController
        },

        ui: {
            dropdown:        ".dropdown.more",
            dropdownLinks:   ".more .dropdown-menu li",
            shareMenu:       ".share.menu-item",
            toggleComments:  ".toggle-comments",
            addComment:      ".add-comment"
        },

        regions: {
            shareMenu: ".share.menu-item"
        },

        templateHelpers: function() {
            return {
                isEmailInCreatorEnabled: LoggedInUserState.get("companySettings").get("isCreatorInEmailEnabled")
            };
        },

        onRender: function() {
            this.stickit(this.options.experience, this.experienceBindings);
        },

        onShow: function() {
            this.shareMenu.show(new ShareButton({
                experience: this.options.experience,
                route: null,
                modal: true,
                hideTooltip: true
            }));
        },

        hide: function() {
            this.ui.dropdown.toggleClass("open", false);
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/editor/editorMoreMenu/EditorMoreMenuView.js